import { Component, OnInit, Input } from '@angular/core';
import { MenuController } from '@ionic/angular';

@Component({
  selector: 'app-header',
  templateUrl: './header.component.html',
  styleUrls: ['./header.component.scss'],
})
export class HeaderComponent implements OnInit {
  @Input() titulo: string;
  ver=false;

  constructor( private menuController: MenuController) {
   // console.log(this.titulo);
   this.ocultar()

   }

   ocultar(){
      if(this.ver=== false){
        this.ver=true;
        this.menuController.open()
      }else {
        this.ver = false;
        this.menuController.close()
      }

      
   }

  ngOnInit() {}

}
